export const removeBlankSpaces = (str: string) => {
  return str.replace(/(\u2000| )/gi, "");
};
